module.exports = __webpack_public_path__ + "assets/bc501449c664543829c12c293d7a0c7f.png";